import { render, staticRenderFns } from "./advert-stub.vue?vue&type=template&id=b3ee83ba"
import script from "./advert-stub.vue?vue&type=script&lang=ts"
export * from "./advert-stub.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports